import {
  File,
  FileCsv,
  FileDoc,
  FileImage,
  FilePdf,
  FilePpt,
  FileText,
  FileXls,
  FileZip,
  type Icon,
} from '@phosphor-icons/react';

/**
 * Pick a Phosphor icon for a document from its file extension, falling back to
 * a generic file icon for unknown/extension-less names.
 */
export const getFileTypeIcon = (fileName?: string | null): Icon => {
  const ext = fileName?.includes('.')
    ? (fileName.split('.').pop() ?? '').toLowerCase()
    : '';

  switch (ext) {
    case 'pdf':
      return FilePdf;
    case 'doc':
    case 'docx':
      return FileDoc;
    case 'ppt':
    case 'pptx':
      return FilePpt;
    case 'xls':
    case 'xlsx':
      return FileXls;
    case 'csv':
      return FileCsv;
    case 'png':
    case 'jpg':
    case 'jpeg':
    case 'gif':
    case 'webp':
    case 'bmp':
    case 'svg':
    case 'heic':
      return FileImage;
    case 'txt':
    case 'md':
    case 'rtf':
      return FileText;
    case 'zip':
      return FileZip;
    default:
      return File;
  }
};

// Upload types the document viewer can display: the backend normalizes each of
// these to a viewer-ready PDF (office docs via the ora-doc-converter service,
// images and text via pdf-lib). Keep in sync with ora-be's buildViewerPdf.
const VIEWABLE_DOCUMENT_EXTENSIONS = new Set([
  'pdf',
  'ppt',
  'pptx',
  'doc',
  'docx',
  'png',
  'jpg',
  'jpeg',
  'txt',
  'csv',
]);

/**
 * True when the document viewer can render this upload — "View Document" links
 * are gated on this.
 */
export const isViewableDocumentFileName = (
  fileName?: string | null
): boolean => {
  const ext = fileName?.includes('.')
    ? (fileName.split('.').pop() ?? '').toLowerCase()
    : '';

  return VIEWABLE_DOCUMENT_EXTENSIONS.has(ext);
};
